// extracted by mini-css-extract-plugin
export var tosLink = "_6a-0";